import { Route, Switch } from 'react-router-dom';
// @ts-expect-error not typed
import UniversalApplicationContainer from 'ContentEditorUI/containers/UniversalApplicationContainer';
// @ts-expect-error not typed
import AsyncComponentContext from 'ContentEditorUI/context/AsyncComponentContext';
import ContentViewContainer from '../../editor/components/ContentViewContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const basePath = '/:articleId';
const concatPaths = path => `${basePath}/${path}`;
const Routes = () => {
  return /*#__PURE__*/_jsx(Route, {
    path: basePath,
    children: /*#__PURE__*/_jsx(UniversalApplicationContainer, {
      children: /*#__PURE__*/_jsxs(Switch, {
        children: [/*#__PURE__*/_jsx(Route, {
          path: concatPaths('content'),
          exact: true,
          children: /*#__PURE__*/_jsx(ContentViewContainer, {})
        }), /*#__PURE__*/_jsx(Route, {
          path: concatPaths('preview'),
          exact: true,
          children: /*#__PURE__*/_jsx(AsyncComponentContext.Consumer, {
            children: ({
              PreviewModal
            }) => /*#__PURE__*/_jsx(PreviewModal, {})
          })
        }), /*#__PURE__*/_jsx(Route, {
          path: concatPaths('revisions'),
          exact: true,
          children: /*#__PURE__*/_jsx(AsyncComponentContext.Consumer, {
            children: ({
              RevisionHistory
            }) => /*#__PURE__*/_jsx(RevisionHistory, {})
          })
        })]
      })
    })
  });
};
export default Routes;